
import saMessages from '../locales/ko_KO';

const koLang = {
    messages: {
        ...saMessages
    },
    locale: 'ko-ko',

};

export default koLang;
